import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { path: '/history', label: 'تاریخچه', icon: '📋' },
  { path: '/balance', label: 'موجودی', icon: '💰' },
  { path: '/usage', label: 'مصرف', icon: '📊' },
  { path: '/plans', label: 'پلن‌ها', icon: '📦' },
  { path: '/transactions', label: 'تراکنش‌ها', icon: '💳' },
];

export const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <nav style={styles.nav}>
      <div style={styles.container}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                ...styles.navItem,
                ...(isActive ? styles.navItemActive : {}),
              }}
            >
              <div style={styles.icon}>{item.icon}</div>
              <div style={styles.label}>{item.label}</div>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

const styles: Record<string, React.CSSProperties> = {
  nav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e0e0e0',
    boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.05)',
    zIndex: 100,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-around',
    maxWidth: '768px',
    margin: '0 auto',
  },
  navItem: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0.6rem 0.25rem',
    textDecoration: 'none',
    color: '#666',
    transition: 'color 0.2s',
    minHeight: '56px',
  },
  navItemActive: {
    color: '#646cff',
    fontWeight: 600,
  },
  icon: {
    fontSize: '1.25rem',
    marginBottom: '0.2rem',
  },
  label: {
    fontSize: '0.65rem',
    textAlign: 'center',
  },
};
